/**
 * Account Dropdown
 * Transforms the header account dropdown into a two-panel layout:
 * left promotional panel + right login form (moved from #loginModal).
 *
 * The panel markup lives in backup.html (placed on the page via the
 * admin footer `.account-dropdown-source` block). This script
 * moves it into the platform's `.account-dropdown`, wires the dynamic
 * Request Account href and login form, then removes the source block.
 *
 * For logged-out users the dropdown opens on click
 * instead of the platform's default mouseover/mouseout behaviour.
 */
(() => {
  const dropdown = document.querySelector('.account-dropdown');
  const loginForm = document.querySelector('#loginModal .login-form');
  const source = document.querySelector('.account-dropdown-source');
  if (!dropdown || !loginForm || !source) return;

  try {
    const wrapper = source.querySelector('.account-dropdown__wrapper');
    const closeBtn = source.querySelector('.account-dropdown__close');
    const formSlot = source.querySelector('.account-dropdown__form-slot');
    const modalLinks = source.querySelector('.account-dropdown__modal-links');
    if (!wrapper || !closeBtn || !formSlot) return;

    const requestAccountLink = dropdown.querySelector('.signin_register a');
    const requestAccountHref = requestAccountLink?.href || '#';
    source.querySelectorAll('.js-request-account').forEach((link) => {
      link.href = requestAccountHref;
    });

    const overlap = dropdown.querySelector('.overlap');

    dropdown.innerHTML = '';

    if (overlap) dropdown.appendChild(overlap);
    dropdown.appendChild(wrapper);

    formSlot.appendChild(loginForm);

    const loginModal = document.querySelector('#loginModal .modal-body');
    if (loginModal && modalLinks) {
      loginModal.prepend(modalLinks);
    }

    source.remove();

    // --- Click-to-open for logged-out users ---
    if (document.body.classList.contains('ex-loggedout')) {
      const toggle = dropdown.closest('.shoppingtools_container .dropdown');
      if (!toggle) return;

      const accountBtn = toggle.querySelector('.account-btn');
      if (!accountBtn) return;

      // Strip Bootstrap's data-toggle so its dropdown JS doesn't interfere
      accountBtn.removeAttribute('data-toggle');

      const killHover = (e) => {
        e.stopImmediatePropagation();
        e.preventDefault();
      };

      toggle.addEventListener('mouseenter', killHover, true);
      toggle.addEventListener('mouseleave', killHover, true);
      toggle.addEventListener('mouseover', killHover, true);
      toggle.addEventListener('mouseout', killHover, true);

      toggle.classList.remove('open');

      closeBtn.addEventListener('click', () => {
        toggle.classList.remove('open');
      });

      accountBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle.classList.toggle('open');
      });

      // Clicks inside the dropdown menu should not close it
      dropdown.addEventListener('click', (e) => {
        e.stopPropagation();
      });

      document.addEventListener('click', (e) => {
        if (!toggle.contains(e.target)) {
          toggle.classList.remove('open');
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          toggle.classList.remove('open');
        }
      });
    }
  } catch (error) {
    console.error('Error: .account-dropdown', error);
  }
})();
